<template>
  <div class="device_page">
    <el-form :inline="true">
      <el-form-item>
        <el-input
          v-model="assetNumber"
          prefix-icon="el-icon-search"
          :placeholder="$t('lang.请输入资产号')"
        >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.时间')">
        <el-radio-group v-model="radioData" @input="handleRadioData">
          <el-radio-button label="date">{{ $t("lang.日") }}</el-radio-button>
          <el-radio-button label="month">{{ $t("lang.月") }}</el-radio-button>
          <el-radio-button label="year">{{ $t("lang.年") }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="selectPrice"
          :type="radioData"
          :placeholder="$t('lang.选择日期')"
          :key="datePickerKey"
          value-format="yyyy-MM-dd HH:mm:ss"
          :clearable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onClickSearch">
          {{ $t("lang.查询") }}
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="onClickExport">
          {{ $t("lang.导出") }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" height="2.8rem">
      <el-table-column
        v-for="item in tableLabel"
        :key="item.prop"
        :label="$t('lang.' + item.label)"
        :prop="item.prop"
        :width="item.width"
        align="center"
        :formatter="formatter"
      ></el-table-column>
    </el-table>
    <div class="payment_bottom">
      <el-pagination
        class="bottom_page"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :current-page="params.pageNum"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizes"
        :page-size="10"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { tableLabel } from "./define";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      loading: false,
      radioData: "date",
      assetNumber: "",
      selectPrice: moment(new Date()).format("YYYY-MM-DD 00:00:00"),
      tableLabel: tableLabel,
      tableData: [],
      datePickerKey: 0,
      params: {
        pageNum: 1,
        pageSize: 24,
      },
      totalCount: 0,
      pageSizes: [24, 48, 72, 96, 120],
    };
  },
  created() {
    this.getDeviceListHIstoryData();
  },
  methods: {
    ...mapActions({
      deviceListHistoryData: "ZD_DeviceListHistoryData",
    }),
    async getDeviceListHIstoryData() {
      this.loading = true;
      try {
        let params = {
          searchValue: this.assetNumber,
          dataType: this.dataFilter(this.radioData),
          dateTime: this.selectPrice,
          deviceType: 0,
          pageNum: this.params.pageNum,
          pageSize: 1,
        };
        let res = await this.deviceListHistoryData(params);
        if (res.success !== 1) return;
        res.listitem.forEach((elem, index) => {
          elem.idx =
            (this.params.pageNum - 1) * this.params.pageSize + index + 1;
        });
        this.tableData = res.listitem;
        switch (params.dataType) {
          case 2:
            this.totalCount = res.totalItemCount * 24;
            break;
          case 3:
            this.totalCount =
              res.totalItemCount * this.getDayNum(this.selectPrice);
            break;
          case 4:
            this.totalCount = res.totalItemCount * 12;
            break;
          default:
            this.totalCount = 0;
            break;
        }
      } catch {
        this.totalCount = 0;
        this.tableData = [];
      } finally {
        this.loading = false;
      }
    },
    onClickSearch() {
      this.params.pageNum = 1;
      if (this.radioData == "date") {
        this.params.pageSize = 24;
        this.pageSizes = [24, 48, 72, 96, 120];
      } else if (this.radioData == "year") {
        this.params.pageSize = 12;
        this.pageSizes = [12, 24, 36, 48, 60];
      } else if (this.radioData == "month") {
        let monthDay = this.getDayNum(this.selectPrice);
        this.params.pageSize = monthDay;
        this.pageSizes = [
          monthDay,
          monthDay * 2,
          monthDay * 3,
          monthDay * 4,
          monthDay * 5,
        ];
      }
      this.getDeviceListHIstoryData();
    },
    onClickExport() {
      if (this.isnull(this.tableData))
        return this.$message.warning(this.$t("lang.当前无导出数据"));
      const tempTitle = this.docopy(this.tableLabel);
      tempTitle.shift();
      tempTitle.forEach((elem) => {
        elem.label = this.$t("lang." + elem.label);
      });
      let params = {
        searchValue: this.assetNumber,
        dataType: this.dataFilter(this.radioData),
        dateTime: this.selectPrice,
        deviceType: 0,
        pageNum: this.params.pageNum,
        pageSize: 0,
      };
      this.$download(params, tempTitle, "EXPORT_HistoryListData");
    },
    handleRadioData() {
      this.datePickerKey += 1;
      this.onClickSearch();
    },
    handleCurrentChange(val) {
      this.params.pageNum = val;
      this.getDeviceListHIstoryData();
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getDeviceListHIstoryData();
    },
    dataFilter(val) {
      switch (val) {
        case "date":
          return 2;
        case "month":
          return 3;
        case "year":
          return 4;
      }
    },
    formatter(row, { property }) {
      if (this.isnull(row[property])) return "--";
      if (
        property == "totalenergy" ||
        property == "ua" ||
        property == "ub" ||
        property == "uc" ||
        property == "ia" ||
        property == "ib" ||
        property == "ic" ||
        property == "pfa"
      )
        return this.fix(row[property]);
      return row[property];
    },
    //根据年月得到天数
    getDayNum(time = "") {
      let tempTimes = time.split("-");
      if (this.isnull(time) || tempTimes.length < 2) return 30;
      switch (tempTimes[1] - 0) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          return 31;
        case 4:
        case 6:
        case 9:
        case 11:
          return 30;
        case 2:
          return this.isLeapYear(tempTimes[0] - 0) ? 29 : 28;
      }
    },
    //是否是闰年
    isLeapYear(year) {
      if ((year / 4 == 0 && year / 100 != 0) || year / 400 == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang='less'>
.device_page {
  margin-top: 20px;
}
.el-form {
  .el-form-item {
    margin-right: 24px;
  }
}
.payment_bottom {
  width: 100%;
  height: 60px;
  .bottom_page {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
</style>
